import styled from 'styled-components';
import { IPOStyleCommon, IPOStyleMixins } from '../../../styles/index';

export const EditUserWrap = styled.div`
	.form-title--wrap {
		${IPOStyleMixins.flex('row', 'center', 'center')};
		margin-bottom: 20px;

		.title-name {
			color: ${IPOStyleCommon.IPOColors.text.textSlight};
			cursor: pointer;
			padding: 0 14px;

			:first-child {
				border-right: 1px solid #ebecf0;
			}

			&.active {
				color: ${IPOStyleCommon.IPOColors.blue.secondBlueColor};
			}
		}
	}
	.modal-wrap {
		.ant-modal {
			position: relative;
		}
	}
	.disabled-modal {
		.ant-modal {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -105%);
		}
	}
`;

export const FooterWrap = styled.div`
	width: 100%;
	${IPOStyleMixins.flex('row', 'space-between', 'center')}
`;
